export const maskAccountNumber = (accNumber?: string | null) => {
  if (!accNumber) {
    return '****';
  }

  if (accNumber.length <= 4) {
    const masked = '*'.repeat(4 - accNumber.length);
    return `${masked}${accNumber}`;
  }

  const masked = '*'.repeat(4);
  const visible = accNumber.slice(-4);
  return `${masked}${visible}`;
};

export const subAccountTypeMapping = {
  ChargeCard: 'Charge Card',
  CreditCard: 'Credit Card',
  CurrentAccount: 'Current Account',
  EMoney: 'E-Money',
  Loan: 'Loan',
  Mortgage: 'Mortgage',
  PrepaidCard: 'Prepaid Card',
  Savings: 'Savings'
} as const;

export const mapToSubAccountType = (type: keyof typeof subAccountTypeMapping) => {
  return subAccountTypeMapping[type] || type.toLowerCase();
};
